export const SET_PORTFOLIO_FILTER = 'SET_PORTFOLIO_FILTER';
export const SET_PORTFOLIO_LIST = 'SET_PORTFOLIO_LIST'
export const SET_PORTFOLIO_HELDAWAY_STATUS = 'SET_PORTFOLIO_HELDAWAY_STATUS'
export const SET_SELECTED_PORTFOLIO_OBJECT = "SET_SELECTED_PORTFOLIO_OBJECT"
export const SET_EXPIRING_MANDATE_STATUS = "SET_EXPIRING_MANDATE_STATUS"
// Snapshot of the logged-in investor's portfolio context. Stays stable even
// when the user navigates to another investor's profile via the Family flow,
// so the sidebar can always operate on the logged-in user's context.
export const SET_LOGGED_IN_PORTFOLIO_FILTER = 'SET_LOGGED_IN_PORTFOLIO_FILTER'
export const SET_LOGGED_IN_SELECTED_PORTFOLIO_OBJECT = 'SET_LOGGED_IN_SELECTED_PORTFOLIO_OBJECT'
export const SET_LOGGED_IN_PORTFOLIO_LIST = 'SET_LOGGED_IN_PORTFOLIO_LIST'
export const SET_LOGGED_IN_PORTFOLIO_HELDAWAY_STATUS = 'SET_LOGGED_IN_PORTFOLIO_HELDAWAY_STATUS'